import * as yup from "yup";

export interface ThirdPartyViewModel {
    materialSpecId: number;
    adMaterialId: number;
    tag: string;
    sgCode: number;
    description: string;
}

export interface ThirdPartyUpdateValues {
    materialSpecificationId: number;
    adMaterialId: number;
    sgCode?: number;
    tag?: string;
    pixelTracker?: string;
    description?: string;
    url?: string;
}

export interface NewMaterialThirdPartyValues {
    materialSpecificationId: number;
    tag: string;
    pixelTracker: string;
    description: string;
    url: string;
    sgCode: string;
}

export interface ThirdPartyTagRuleForm {
    sgCode: string;
    tag: string;
    pixelTracker: string;
    description: string;
    url: string;
}

export const thirdPartyTagFormDefaultValues: ThirdPartyTagRuleForm = {
    sgCode: "",
    tag: "",
    pixelTracker: "",
    description: "",
    url: "",
};

// todo: when proper validation is defined
// eslint-disable-next-line
export const thirdPartyTagSchema = (isTagRequired: boolean) => {
    return yup.object().shape({
        sgCode: yup.string(),
        // tag: isTagRequired ? yup.string().required("Third party is a required field") : yup.string(),
        tag: yup.string(),
        pixelTracker: yup.string(),
        description: yup.string(),
        url: yup.string().url(),
    });
};
